import MaterialUiCardContent from "@material-ui/core/CardContent";
import * as React from "react";

export const CardContent: React.FC = props => (
  <MaterialUiCardContent {...props} />
);
